import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { HowItWorksFileEvent } from "@/app/types/home/HowItWorksMockData";
import { UStyles } from "@/app/utils/UStyles";
import {
  formatMockDate,
  percentWidth,
  sellerShare,
  talkLabel,
  withCount,
} from "./HowItWorks.logic";
import styles from "./HowItWorksMock.module.css";

type Props = {
  event: HowItWorksFileEvent;
};

export default function HowItWorksMockFileEvent(props: Props) {
  const { event } = props;
  const { passage, commitment, deal, metrics } = event;
  const T = useT();

  return (
    <div className={styles.event}>
      <span className={styles.eventNode}>
        <event.Icon />
      </span>
      <span className={styles.eventBody}>
        <span className={styles.eventHead}>
          <span className={styles.meta}>
            {`${T(event.titleKey)} · ${formatMockDate(event.date, T)}`}
          </span>
          {metrics && (
            <span className={styles.metrics}>
              <span className={styles.talkBar}>
                <span
                  className={styles.talkFill}
                  style={{ width: percentWidth(sellerShare(metrics.customerShare)) }}
                />
              </span>
              {`${talkLabel(T(TKey.HOME_MEIDLY_HOW_FILE_TALK), metrics.customerShare)} · ${withCount(
                T(TKey.HOME_MEIDLY_HOW_FILE_INTERRUPTIONS),
                metrics.interruptions,
              )}`}
            </span>
          )}
        </span>

        {passage && (
          <span className={styles.eventItem}>
            <span className={UStyles.classNames(styles.tag, styles[passage.toneClass])}>
              {T(passage.labelKey)}
            </span>
            <span className={styles.itemText}>{T(passage.quoteKey)}</span>
          </span>
        )}

        {commitment && (
          <span className={styles.eventItem}>
            <span className={styles.checkbox} />
            <span className={styles.itemText}>{T(commitment.actionKey)}</span>
            <span
              className={UStyles.classNames(
                styles.itemAside,
                commitment.isOverdue ? styles.overdue : "",
              )}
            >
              {T(commitment.dueKey)}
            </span>
          </span>
        )}

        {deal && (
          <span className={styles.eventItem}>
            <span className={styles.itemText}>{T(deal.titleKey)}</span>
            <span className={styles.status}>
              <span className={UStyles.classNames(styles.statusDot, styles[deal.toneClass])} />
              {T(deal.stageKey)}
            </span>
          </span>
        )}
      </span>
    </div>
  );
}
